export {
  initialEvents as calendarEvents,
  resources as calendarResources,
  defaultVisibleDate as calendarDefaultVisibleDate,
} from '../../../../../../data/scheduler/datasets/personal-agenda';

export {
  initialEvents as timelineEvents,
  resources as timelineResources,
  defaultVisibleDate as timelineDefaultVisibleDate,
} from '../../../../../../data/scheduler/datasets/company-roadmap';
